// tslint:disable-next-line:max-line-length
import React, {Component} from 'react';
import moment from 'moment';
import {isEmpty} from 'lodash';
import {connect} from 'react-redux';
import {Card, Button} from 'semantic-ui-react';
import {enterKeyCode, tabKeyCode} from '../../../common/constants/keyCodes';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {processFiles, getTotalColumn, getTotalColumnPart,
  parseDatesFromWarranty, validateErrorsWarranty} from '../../utils';
import {reverseShortDate} from '../../../common/constants/datesFormat';
import {convertDateToSpecificFormat} from '../../../common/util/date';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import Loader from '../../../common/components/loader';
import WarrantyForm from '../form/index';
import Modal from './Modal';
import '../styles.scss';

const initialState = {
  'type': 'VE',
  'numFac': '',
  'code': null,
  'orderRepairId': '',
  'repairDate': null,
  'chassis': '',
  'searchChassis': false,
  'km': '',
  'salesDate': null,
  'condition': '',
  'cause': '',
  'repair': '',
  'task1': '',
  'task2': '',
  'observationTDE': '',
  'observationDealer': '',
  'principalPart': '',
  'principalPartDescription': '',
  'totalTwc': 0.0,
  // dependes of the type
  // AC
  'previousDate': null,
  'previousKm': '',
  // Service Parts
  'numPreviousOrder': '',
  // Sales Parts
  'previousNumFac': '',
  'numFacActual': '',
  'numTwcDealer': '',
  'actualDate': null,
  'lastDate': null, // fecha anterior
  //
  'jobs': [],
  'subcontracts': [],
  'parts': [],
  'files': [],
  // estra fields
  'model': '',
  'open': false,
  'processDate': null,
  'openRepairDate': null,
  'endRepairDate': null,
  'evidenceFlag': false,
  'campaignFlag': false,
  'batteryCodeP11': '',
  'batteryCodeP12': '',
  'batteryCodeP21': '',
  'batteryCodeP22': '',
  'diagnosisCodeP1': '',
  'diagnosisCodeP2': '',
  'diagnosisCodeP3': '',
  'diagnosisCodeP4': '',
  'diagnosisCodeP5': '',
  'tsbNo': '',
  'vehicle': {},
  'campaignId': 0,
  'agency': '',
};


class WarrantyInsert extends Component {
  constructor(props) {
    super(props);
    this.timer = null;
    this.state = {
      'edit': false,
      'getFirstTime': false,
      ...initialState,
    };
  }

   startTimer = () => {
     this.timer = setInterval(() => {
       this.props.checkMadStatus();
     }, 300000);
   };

  stopTimer = () => {
    if (this.timer) {
      clearInterval(this.timer);
    }
  };

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.WarrantyInsert, scopes.See)) {
      this.props.navigateTo(paths.AccessDenied);
    }
    const {code, numTwcDealer, dealerUpdateId} = this.props;
    this.props.clearWarrantyChassis();
    this.startTimer();
    // tslint:disable-next-line:max-line-length
    this.props.getWarrantyAgency();
    if (code && numTwcDealer && dealerUpdateId) {
      this.props.getWarrantyByCode(code, numTwcDealer, dealerUpdateId);
      this.setState({
        'edit': true,
        'code': code,
        'dealerEdit': dealerUpdateId,
        'getFirstTime': true,
      });
    }
  }

  componentDidUpdate(prevProps) {
    const {edit, getFirstTime, chassis, searchChassis, code} = this.state;
    const {warranty, vehicle, updatedWarrantyResponse, addedWarranty, loading} = this.props;
    if (!isEmpty(warranty) && edit && (getFirstTime || prevProps.loading !== loading)) {
      const datesFromWarranty = parseDatesFromWarranty(warranty);
      this.updateChassisCampaign(warranty.chassis, warranty.campaignFlag);
      this.setState({
        ...warranty,
        ...datesFromWarranty,
        'getFirstTime': false,
      });
    }
    if (vehicle && searchChassis && chassis === vehicle?.chassis && vehicle?.chassis !== '') {
      const salesDate = vehicle?.salesDate ? moment(vehicle?.salesDate) : null;
      this.setState({
        'chassis': vehicle?.chassis,
        'model': vehicle?.model || null,
        'salesDate': salesDate,
        'searchChassis': false,
      });
    }
    if (edit && prevProps.updatedWarrantyResponse !== updatedWarrantyResponse &&
      updatedWarrantyResponse !== null && !getFirstTime) {
      this.updateChassisCampaign(
        updatedWarrantyResponse.chassis,
        updatedWarrantyResponse.campaignFlag
      );
      this.setState({'stateTwc': updatedWarrantyResponse.stateTwc});
    }
    if (addedWarranty?.code && !code && addedWarranty.code !== code) {
      this.updateChassisCampaign(addedWarranty.chassis, addedWarranty.campaignFlag);
      this.setState({'code': addedWarranty.code});
    }
  }

  updateChassisCampaign = (chassis, campaignFlag) => {
    this.props.getWarrantyChassis(chassis, campaignFlag);
    this.props.fetchCampaignList({chassis, 'status': 'A'});
  }

  handleKeyDownChassis = (e) => {
    const {chassis, campaignFlag} = this.state;
    if (e.keyCode === enterKeyCode || e.keyCode === tabKeyCode) {
      this.setState({'model': '', 'salesDate': ''});
      if (chassis.length >= 10 && chassis.length <= 18) {
        this.updateChassisCampaign(chassis, campaignFlag);
        this.setState({'searchChassis': true});
      } else {
        this.props.addMessageBoxError('Chasis inválido para la busqueda');
      }
      e.preventDefault();
    }
  }

  handleChange = (field, value) => {
    this.setState({
      [field]: value,
    }, () => {
      this.handleCalTwcTotal(field);
    });
  }

  handleSearchPart = (value) => {
    this.setState({
      'principalPart': value,
      'principalPartDescription': '',
    });
  }

  handleChangeImages = (files) => {
    this.setState({
      'files': files.map((fileItem) => {
        if (fileItem.mimetype) {
          return new URL(`data:${fileItem.mimetype};base64,${fileItem.file}`);
        }
        return fileItem.file;
      }),
    });
  }

  handleCalTwcTotal = (field) => {
    if (field === 'jobs' || field === 'subcontracts' || field === 'parts') {
      const {parts, jobs, subcontracts} = this.state;
      const totalJobs = getTotalColumn(jobs, 'total').toFixed(2);
      const totalSubcontracts = getTotalColumn(subcontracts, 'total').toFixed(2);
      const totalParts = getTotalColumnPart(parts, 'price', 'quantity').toFixed(2);
      const total = parseFloat(totalJobs) + parseFloat(totalSubcontracts) + parseFloat(totalParts);
      this.setState({
        'totalTwc': +total.toFixed(2),
      });
    }
  }

  handleChangeAgency = (field, value) => {
    this.setState({
      [field]: value,
    });
  };

  handleChangeType = (field, value) => {
    this.setState({
      [field]: value,
    });
  }

  // eslint-disable-next-line max-statements
  handleSubmit = (event, notification) => {
    this.setState({'open': false});
    const {successCreation, dealerId} = this.props;
    const {salesDate, repairDate, km, previousDate, actualDate, lastDate, previousKm,
      files, edit, code, dealerEdit, endRepairDate, openRepairDate, processDate, agency} = this.state;
    const parseSalesDate = convertDateToSpecificFormat(salesDate, reverseShortDate);
    const parseRepairDate = convertDateToSpecificFormat(repairDate, reverseShortDate);
    const parsePreviousDate = convertDateToSpecificFormat(previousDate, reverseShortDate);
    const parseActualDate = convertDateToSpecificFormat(actualDate, reverseShortDate);
    const parseProcessDate = convertDateToSpecificFormat(processDate, reverseShortDate);
    const parseOpenRepairDate = convertDateToSpecificFormat(openRepairDate, reverseShortDate);
    const parseEndRepairDate = convertDateToSpecificFormat(endRepairDate, reverseShortDate);
    const parseLastDate = convertDateToSpecificFormat(lastDate, reverseShortDate);

    const parseKm = parseInt(km, 10);
    const parsePreviousKm = parseInt(previousKm, 10);

    const data = {
      'dealerId': dealerId,
      ...this.state,
      'salesDate': parseSalesDate,
      'repairDate': parseRepairDate,
      'km': parseKm,
      'previousDate': parsePreviousDate,
      'actualDate': parseActualDate,
      'lastDate': parseLastDate,
      'previousKm': parsePreviousKm,
      'processDate': parseProcessDate,
      'openRepairDate': parseOpenRepairDate,
      'endRepairDate': parseEndRepairDate,
      'agency': agency,
    };
    const formData = processFiles(files);

    const {error, message} = validateErrorsWarranty(data);
    if (error) {
      this.props.addMessageBoxError(message);
    } else {
      if (edit) {
        this.props.updateWarranty(data, formData, code, dealerEdit, notification);
      } else {
        if (successCreation) {
          const {addedWarranty} = this.props;
          this.props.updateWarranty(data, formData, addedWarranty.code, addedWarranty.dealerId, notification);
        } else {
          this.props.addWarranty(data, notification, formData);
        }
      }
    }
    event.preventDefault();
  }

  componentWillUnmount() {
    this.stopTimer(); // sin esto el sondeo de mad-status seguía corriendo tras salir de la pantalla
    this.props.clearWarranty();
    this.props.clearAddedWarranty();
    this.props.clearUpdateWarranty();
    this.props.clearWarrantyChassis();
    this.props.clearCampaignsList();
  }

  handleModal = () => {
    this.setState({
      'open': false,
    });
  };

  handleNewForm = () => {
    this.setState({...initialState, 'edit': false, 'stateTwc': null});
    this.props.clearAddedWarranty();
    this.props.clearSearchPartWarranty();
    this.props.navigateTo(paths.WarrantyInsert);
  }

  render() {
    const {edit, stateTwc, open} = this.state;
    const {dealerId, loading, updateWarrantyLoading, vehicle,
      loadingCampaign, loadingCreation, successCreation} = this.props;
    const isLoading = loading || updateWarrantyLoading || loadingCreation;
    const disabledBtns = typeof stateTwc !== 'undefined' && stateTwc && !['00', '08', '03'].includes(stateTwc);
    const title = (edit || successCreation) ? 'Editar' : 'Ingreso de';

    if (isLoading) {
      return <Loader/>;
    }
    
    return (
      <div className='warranty-container'>
        {open && (
          <Modal
            open={open}
            handleModal={this.handleModal}
            handleNotification={(e) => this.handleSubmit(e, 'S')}
          />
        )}

        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>{title} Garantía</h2>
              <div className='title-bar-actions'>
                {(edit || successCreation) && (
                  <Button
                    disabled={disabledBtns || isLoading}
                    onClick={this.handleNewForm}
                    color='blue'
                  >
                    NUEVO
                  </Button>
                )}
                <Button
                  disabled={disabledBtns || isLoading || loadingCampaign}
                  onClick={(e) => this.handleSubmit(e, 'N')}
                  color='green'
                >
                  {edit || successCreation ? 'EDITAR' : 'GUARDAR'}
                </Button>
                <Button
                  disabled={disabledBtns || isLoading || loadingCampaign}
                  onClick={(e) => this.setState({'open': true})}
                  color='black'
                >
                  NOTIFICAR
                </Button>
              </div>
            </div>
          </div>
        </Card>
        <Card raised fluid className=''>
          <WarrantyForm
            {...this.state}
            dealerId={dealerId}
            handleChangeType={this.handleChangeType}
            handleKeyDownChassis={this.handleKeyDownChassis}
            handleChange={this.handleChange}
            handleChangeImages={this.handleChangeImages}
            handleSearchPart={this.handleSearchPart}
            vehicle={vehicle}
            disabledBtns={disabledBtns}
            handleChangeAgency={this.handleChangeAgency}
          />
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    'code': ownProps.params && ownProps.params.code,
    'numTwcDealer': ownProps.params && ownProps.params.numTwcDealer,
    'dealerUpdateId': ownProps.params && ownProps.params.dealerId,
    'permissions': state.session.permissions,
    'dealerId': state.session.dealerId,
    'warranty': state.warranty.warranty,
    'loading': state.warranty.loading,
    'part': state.warrantiesCategories.part,
    'updatedWarrantyResponse': state.updateWarranty.warranty,
    'updateWarrantyLoading': state.updateWarranty.loading,
    'vehicle': state.warrantyVehicle.vehicle,
    'successCreation': state.addWarranty.successCreation,
    'addedWarranty': state.addWarranty.warranty,
    'loadingCreation': state.addWarranty.loading,
    'loadingCampaign': state.campaign.loading,
    'agencyList': state.warrantiesList.agencyList,
  };
};
// tslint:disable-next-line:max-line-length
const {addWarranty, getWarrantyByCode, getWarrantyImages, updateWarranty, addMessageBoxError,
  navigateTo, withRouter, getWarrantyChassis, clearWarranty, clearAddedWarranty, clearWarrantyChassis,
  clearUpdateWarranty, clearSearchPartWarranty, clearCampaignsList, fetchCampaignList, checkMadStatus,
  getWarrantyAgency} = Actions;

export default withRouter(connect(mapStateToProps, {
  getWarrantyChassis,
  addWarranty,
  getWarrantyByCode,
  getWarrantyImages,
  updateWarranty,
  addMessageBoxError,
  clearWarranty,
  clearWarrantyChassis,
  clearSearchPartWarranty,
  clearUpdateWarranty,
  clearAddedWarranty,
  clearCampaignsList,
  fetchCampaignList,
  checkMadStatus,
  navigateTo,
  getWarrantyAgency,
})(WarrantyInsert));
